var _defs, _g, _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardLeftJankIconNormal = function SvgNewcsDashboardLeftJankIconNormal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "newcs_dashboard_left_jank_icon_normal_svg___\\u56FE\\u5C42_2",
    width: 20,
    height: 20
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_left_jank_icon_normal_svg__clippath"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z",
    className: "newcs_dashboard_left_jank_icon_normal_svg__cls-2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_left_jank_icon_normal_svg__clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.51 5.48H15.5v10.99H4.51z",
    className: "newcs_dashboard_left_jank_icon_normal_svg__cls-2"
  })), /*#__PURE__*/React.createElement("style", null, ".newcs_dashboard_left_jank_icon_normal_svg__cls-1{stroke:currentColor;stroke-miterlimit:10;stroke-width:.7px}.newcs_dashboard_left_jank_icon_normal_svg__cls-1,.newcs_dashboard_left_jank_icon_normal_svg__cls-2{fill:none}.newcs_dashboard_left_jank_icon_normal_svg__cls-3{fill:currentColor}"))), /*#__PURE__*/React.createElement("g", {
    id: "newcs_dashboard_left_jank_icon_normal_svg___\\u56FE\\u5C42_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#newcs_dashboard_left_jank_icon_normal_svg__clippath)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "newcs_dashboard_left_jank_icon_normal_svg__newcs_dashboard_left_oom_icon_normal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "newcs_dashboard_left_jank_icon_normal_svg___\\u6392\\u9664_4",
    d: "M18 19H2c-1.1 0-2-.9-2-2V3C0 1.9.89 1 1.99.99H18c1.1 0 2 .9 2 2v14c0 1.1-.89 2-1.99 2.01ZM1.5 5v12c0 .28.22.5.5.5h16c.28 0 .5-.22.5-.5V5zM6 2c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.44-1-.99-1.01ZM3 2c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.44-1-.99-1.01Z",
    className: "newcs_dashboard_left_jank_icon_normal_svg__cls-3"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 7.79,
    x: 9.5,
    y: 3.07,
    className: "newcs_dashboard_left_jank_icon_normal_svg__cls-3",
    rx: 0.5,
    ry: 0.5,
    transform: "rotate(90 10 6.96)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 7.79,
    x: 9.5,
    y: 11.48,
    className: "newcs_dashboard_left_jank_icon_normal_svg__cls-3",
    rx: 0.5,
    ry: 0.5,
    transform: "rotate(90 10 15.38)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7 7.28v.82c0 1.48-1.21 2.7-2.7 2.7-1.48 0-2.7-1.21-2.7-2.7v-.82M7.3 14.99v-.91c0-1.48 1.21-2.7 2.7-2.7 1.48 0 2.7 1.21 2.7 2.7v.82",
    className: "newcs_dashboard_left_jank_icon_normal_svg__cls-1"
  }))));
};
export default SvgNewcsDashboardLeftJankIconNormal;